import React from 'react';
import BlogPost from '../../../components/BlogPost';

const AccessControl = () => (
  <BlogPost
    breadcrumbItems={[
      { path: '/', label: 'Home' },
      { path: '/blog', label: 'Blog' },
      { path: '/blog/cloud-security-series', label: 'Cloud Security Series' },
      { path: '/blog/cloud-security-series/access-control', label: 'Access Control' },
    ]}
    title="Access Control"
    date="Jul 25, 2024"
    content={
      <>
        <section className="blog-post__section">
          <p>
            In the previous post we defined steps to implement a bullet-proof Cloud Infrastructure
            Security Posture. Now it's time to dive deep into every topic, and let's start with 🔐{' '}
            <strong>Access Control</strong>.
          </p>
          <p>
            <strong>❓ How would you approach the implementation of the following controls?</strong>
            <br />
            – Establish Centralized Infrastructure Access (User Directory, SSO);
            <br />
            – Implement Role-Based / Permission-based Access Control;
            <br />– Leverage Principle of Least Privilege when establishing and authorizing access.
          </p>
          <p>
            <strong>💪 Here is how, in just five (5) simple steps:</strong>
          </p>
          <ol>
            <li>
              Connect your identity provider (e.g. Google Workspaces, Office 365, etc) to your Cloud
              Provider.
            </li>
            <li>
              Grant cloud infrastructure access on the Group basis, never grant access to
              individuals. This helps define and maintain access permissions based on roles or job
              functions.
            </li>
            <li>
              Take time to write access policies, so you know exactly which resources and services
              you're granting access to. Do not use access policies pre-provisioned by your cloud
              provider. I know it's painful, but you will see that – once created – those policies
              will rarely change, so it is not a waste of time.
            </li>
            <li>Never specify broad permissions in the access policies. Wildcards are a Big NO.</li>
            <li>
              Establish a channel (the Support Ticketing system) for people to request more
              permissions as needed. Make sure all changes go through the ticket, and the ticket
              goes through all necessary approvals. Never honor the verbal, IM'd, or emailed
              requests.
            </li>
          </ol>
          <p>See anything missing or irrelevant?</p>
        </section>
      </>
    }
    cta={{
      title: 'We Are Here to Help!',
      text: "Struggling to set up or simplify your SOC 2 compliance? Our expert team at DevSecOps, Inc. specializes in making compliance manageable and straightforward for lean startups. We've successfully helped numerous startups quickly and affordably achieve compliance without sacrificing agility.",
      buttonText: `Let's Talk`,
      buttonHref: '/contact-us',
    }}
    prevPost={{
      href: '/blog/cloud-security-series/what-is-a-cloud-security-posture',
      label: 'What is a Cloud Security Posture?',
    }}
    nextPost={{
      href: '/blog/cloud-security-series/3',
      label: 'Next: Cloud Security Series #3',
    }}
  />
);

export default AccessControl;
